import { GameId } from '@common'

import { config } from '../../../../../../../config'

export { Countdown } from './Countdown'
export { Footer } from './Footer'
export { Tags } from './Tags'
export { ValueBadge } from './ValueBadge'

const cardsEnabled = config.NEW_CARDS_ENABLED ?? false

export const enableNewCards = (game: GameId) => {
  return (game === 'brawlstars' || game == 'squadbusters') && cardsEnabled
}
export const enableNewSpecialOfferCards = (game: GameId) => {
  return (game === 'brawlstars' || game == 'squadbusters') && cardsEnabled
}
